module.exports = __webpack_public_path__ + "Alex.jpg?e87329b8abdb947d6c51839376ec8bbb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/Alex.jpg
// module id = 47
// module chunks = 0